import { clsx } from "clsx"

import { theme, type ThemeKeys } from "../../theme"
import { textStyles, textVariantMapping } from "../Text"
import styles from "./EditableText.module.css"

export interface EditableTextProps {
  "aria-label": string
  value: string
  color?: ThemeKeys<"color">
  variant?: keyof typeof textVariantMapping
  disabled?: boolean
  onFocus?: () => void
  onBlur?: () => void
  onChange?: (value: string) => void
}

export function EditableText(props: EditableTextProps) {
  const {
    "aria-label": ariaLabel,
    onChange,
    color = "grey12",
    variant = "normal",
    ...otherProps
  } = props

  const className = clsx(styles.input, textStyles[`variant-${variant}`])

  return (
    <div className={styles.root}>
      <input
        {...otherProps}
        aria-label={ariaLabel}
        className={className}
        style={{ color: theme.color[color] }}
        onChange={(evt) => onChange?.(evt.currentTarget.value)}
        inputMode="text"
      />
    </div>
  )
}
